import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class hiprightChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let hiprightlist= visualisationdetails.hipright; 
    
    const data=hiprightlist.map((assmntval) => {  
          return {              
              name: assmntval.assessment,
              iliopsoasright: assmntval.iliopsoasright,
              iliopsoasleft: assmntval.iliopsoasleft,
              piriformisright: assmntval.piriformisright,
              piriformisleft: assmntval.piriformisleft
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis stroke={ChartConfig.axesColor} domain={['auto', 'dataMax + 5']} />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="iliopsoasright" name="Right Iliopsoas Muscle Length" fill={ChartConfig.color.rightshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="iliopsoasleft" name="Left Iliopsoas Muscle Length" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="piriformisright" name="Right Piriformis Muscle Length" fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="piriformisleft" name="Left Piriformis Muscle Length"  fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(hiprightChartComponent); 